module.exports = __webpack_public_path__ + "img/ZZJG.d21d62fa.jpg";